import { Component } from '@angular/core';
import { BreadcrumbService } from '../../core/breadcrumb.service';

@Component({
  standalone: false,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  constructor(public breadcrumb: BreadcrumbService) {}
}
